import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Backdrop, Snackbar } from '@mui/material'
import Alert from '@mui/material/Alert'

import { withStyles } from '@mui/styles'
import { style } from 'styles'

function FeedBack({ classes }) {
	const dispatch = useDispatch()
	const { feedback } = useSelector(state => state.ui)

	const handleClose = () => {
		dispatch({ type: 'setFeedback@ui', message: null, color: feedback.color })
	}

	return (<div>
		<Backdrop className={classes.feedback} open={!!feedback.message} onClick={handleClose} />
		<Snackbar
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
			open={!!feedback.message}
			onClose={handleClose}
			autoHideDuration={feedback.hideDuration}
		>
			<Alert onClose={handleClose} severity={feedback.color} elevation={6} variant="filled">
				{feedback.message}
			</Alert>
		</Snackbar>
	</div>)
}

export default withStyles(style)(FeedBack)
